<template>
	<div class="page-one page-generate">
		<div class="page-generate-content">
			<!-- <div class="generate-ani generate-lantern-l"></div> -->
			<!-- <div class="generate-ani generate-lantern-r"></div> -->
			<div class="generate-content" :style="cStyle">
				<!-- <div class="generate-ani generate-sun" :class="'a'+earthNum"></div> -->
				<div class="generate-earth-box"></div>
				<div class="generate-ani generate-earth" :class="'a'+earthNum"></div>
				<div v-if="inputData.gender == 0" class="generate-ani generate-man" :class="'a'+manNum"></div>
				<div v-if="inputData.gender == 1" class="generate-ani generate-woman" :class="'a'+manNum"></div>
			</div>
			<audio-button></audio-button>
		</div>
	</div>
</template>

<script>
	import { WEIXIN } from '../modules/weixin';
	import AudioButton from '../components/common/AudioButton.vue'
	export default {
		components: { AudioButton },
		computed: {
			gotUserPageData() {
				return this.$store.state.user.gotUserPageData;
			},
			inputData() {
				return this.$store.state.user.inputData;
			}
		},
		data() {
			return {
				height: 640,
				showPop: false,
				manTime: 80, manNum: 1,
				earthTime: 150, earthNum: 1,
				cStyle: ''
			}
		},
		mounted() {
			setTimeout(function() {
				if(!this.gotUserPageData) {
					this.$router.replace('/home');
				}
				this.initDom();
				this.initAnimation();
				this.$bus.emit('playReportAudio');
			}.bind(this), 20);
			// AUDIO.playAudio('generate');
			// todo 优化跳转方案
			setTimeout(function() {
				this.$router.replace('/report');
			}.bind(this), 6000);
		},
		methods: {
			initDom() {
				this.$el.style.height = window.screen.height+'px';
				// var scaleX = parseFloat(innerWidth/750), 
				// 	scaleY = parseFloat(window.screen.height/1334);
				// var cLeft = innerWidth-750, 
				// 	cTop = window.screen.height >= 800 ? scaleY*window.screen.height-window.screen.height-20 : (window.screen.height-1334)/2;
				// // console.error('generate------', cLeft, cTop, innerWidth, window.screen.height)
				// var scaleValue = scaleX > scaleY ? scaleY : scaleX;
				// this.cStyle = this.cStyle+ 'transform: scale('+scaleValue+','+scaleValue+'); left: '+cLeft/2+'px; top: '+cTop+'px';
			},
			initAnimation() {
				var me = this;
				function ani1() {
					me.manNum = me.manNum == 16 ? 1 : me.manNum+1;
					setTimeout(ani1, me.manTime)
				}
				ani1();
				function ani2() {
					me.earthNum = me.earthNum == 32 ? me.earthNum : me.earthNum+1;
					if(me.earthNum < 32) {
						setTimeout(ani2, me.earthTime)
					}
				}
				ani2();
			}
		}
	}
</script>

<style>
	
</style>
